import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import whatsappIcon from '../assets/img/whatsapp-icon.webp';

const WhatsAppButton = () => {
  const { t } = useTranslation();
  const phoneNumber = '+49 15560 348731';  // Número do WhatsApp fornecido
  const message = 'Oi, eu gostaria de mais informações.';  // Mensagem padrão em inglês

  const handleWhatsAppClick = () => {
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  useEffect(() => {
    const handleScroll = () => {
      const whatsappButton = document.querySelector('.whatsapp-button');
      if (whatsappButton) {
        const scrollHeight = document.documentElement.scrollHeight;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const clientHeight = document.documentElement.clientHeight;
  
        // Ajustar o valor do bottom com base na largura da tela
        let bottomValue;
        const screenWidth = window.innerWidth;
  
        if (screenWidth > 1200) {
          // Para telas grandes (desktop)
          bottomValue = '8.25rem';
        } else if (screenWidth > 768) {
          // Para tablets e telas médias
          bottomValue = '10.6rem';
        } else if (screenWidth > 568) {
          // Para tablets e telas médias
          bottomValue = '10.75rem';          
        } else {
          // Para telas pequenas (mobile)
          bottomValue = '17.2rem';
        }
  
        if (scrollTop + clientHeight >= scrollHeight - 20) {
          whatsappButton.style.bottom = bottomValue;
        } else {
          whatsappButton.style.bottom = '0rem';
        }
      }
    };
  
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  

  return (
    <button 
      onClick={handleWhatsAppClick} 
      className="whatsapp-button"
      title={t('contact_us_whatsapp')}
    >
      <img src={whatsappIcon} alt="WhatsApp" />
      {t('contact_us_whatsapp')}
    </button>
  );
};

export default WhatsAppButton;
